import React from 'react'
import AddNPA from './AddNPA'
export default function Main({communityId}) {
  return (
    <>
    <AddNPA communityId={communityId}/>
    </>
  )
}
